// ════════════════════════════════════════════════════════════════════════════
// The closed render taxonomy for attached results (U13, U17).
//
// ┌──────────────────────────────────────────────────────────────────────────┐
// │ THIS ENUM IS NO LONGER THE BLOCK'S DISCRIMINATOR (ruled 2026-08-20:      │
// │ "kind: names the pillar"). A materialised block's `kind:` directive      │
// │ carries the PILLAR its results came from — `pillar-names.ts` prints the  │
// │ value and reads it back — and the FE picks a card family by pillar, so   │
// │ a block's ability to render no longer depends on a member existing here. │
// └──────────────────────────────────────────────────────────────────────────┘
//
// What the three members still name is a PAYLOAD FAMILY: the zod envelope
// schemas (contracts.ts), their builders, and the FE model that maps a payload
// onto a widget family's own type. Retiring them is its own pass, once the
// pillar axis is load-bearing — not this change's motion, because the FE model
// still imports the payload types.
//
// ┌──────────────────────────────────────────────────────────────────────────┐
// │ HERMETIC RULE (U17), AS IT NOW READS. A kind enters this enum ONLY in    │
// │ the same change as:                                                     │
// │   1. its zod payload schema  (payloads/<kind>.payload.ts)                │
// │   2. its BL builder          (apps/bl … attached-result/builders)        │
// │   3. its FE component        (apps/fe … attached-result registry)        │
// │ The rule governs a DEDICATED CARD, never a block's ability to render:    │
// │ every pillar renders today, in its own item format where a projector     │
// │ answers and in the generic titled-link format where none does. A kind    │
// │ whose live captures have not been read yet is NOT a member — it is a     │
// │ blocked pilot, reported as one.                                         │
// └──────────────────────────────────────────────────────────────────────────┘
//
// The FE registry that used to enforce obligation 3 over this enum is now
// exhaustive over `PillarCode` instead (apps/fe/src/components/ui/
// Cattachedresult — `ATTACHED_RESULT_CARDS_BY_PILLAR`), because the pillar is
// what a block names and therefore what a card is chosen by. The compiler
// still forces a decision per pillar; the decision is now "dedicated card, or
// the generic item render".
// ════════════════════════════════════════════════════════════════════════════

export enum AttachedResultKind {
  /** Generic rich link cards — thumbnail, title, snippet, host. Derivable
   *  from ANY pillar's row record, which is what makes attach total from day
   *  one: a pillar with no format of its own renders as these items (U18). */
  Links = 'links',
  /** Properties with a stay: price, rating, the search's own dates. */
  Hotels = 'hotels',
  /** Itineraries with a journey: segments, layovers, the party the whole
   *  price buys. */
  Flights = 'flights',
}
